module.exports = __webpack_public_path__ + "img/ubuntu-mono-dark.8d6989a1.png";